import React from 'react';
import RouteRenderer from './RouteRenderer';

export default class SimpleRoute extends React.Component {
  render() {
    return <RouteRenderer hasAccess {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/route/SimpleRoute.js